import { CartRepositoryInterface } from "../repositories/CartRepositoryInterface";
import { CartRepositoryProvider } from "../services/CartRepositoryProvider";

export class CartSdkMethods {
    public constructor(
        private readonly cartRepositoryProvider: CartRepositoryProvider
    ) {}

    public setCustomCartRepository(cartRepository: CartRepositoryInterface) {
        this.cartRepositoryProvider.setRepository(cartRepository);
    }
}
